/* tslint:disable:max-line-length */
import formatCurrency from '../utilities/formatCurrency'

export type GECampaign = {
  currency: 'USD' | 'CAD'
  guaranteed_earnings: number
  id: number
  is_expired: boolean
  num_days_to_complete: number
  num_deliveries_required: number
  submarket_name: string
}

export const generateTestStub = (options = {}) => ({
  currency: null,
  guaranteed_earnings: 100000,
  id: 1,
  is_expired: false,
  num_days_to_complete: 10,
  num_deliveries_required: 100,
  submarket_name: 'Silicon Valley',
  ...options,
})

const currencySymbols = {
  USD: '$',
  CAD: 'CA$',
}

const getEarningsString = (guaranteedEarningsCampaign: GECampaign) =>
  `${currencySymbols[guaranteedEarningsCampaign.currency] ||
    '$'}${formatCurrency(guaranteedEarningsCampaign.guaranteed_earnings, {
    showCents: false,
  })}`

export const getTitleCopy = guaranteedEarningsCampaign =>
  `Earn ${getEarningsString(guaranteedEarningsCampaign)} for ${
    guaranteedEarningsCampaign.num_deliveries_required
  } deliveries in ${guaranteedEarningsCampaign.submarket_name} guaranteed*`

export const getTermsCopy = guaranteedEarningsCampaign =>
  `This offer is for new Dasher independent contractors only.  To be eligible for this guarantee of ${getEarningsString(
    guaranteedEarningsCampaign
  )}, click on an ad advertising the guarantee of ${getEarningsString(
    guaranteedEarningsCampaign
  )} which will send you to a qualified sign up page. You must sign up through a qualified sign up page that displays the guarantee of ${getEarningsString(
    guaranteedEarningsCampaign
  )} on the sign up page. This guarantee is for ${getEarningsString(
    guaranteedEarningsCampaign
  )} in total earnings for your first ${
    guaranteedEarningsCampaign.num_deliveries_required
  } trips as a new Dasher if you complete those ${
    guaranteedEarningsCampaign.num_deliveries_required
  } trips in your first ${
    guaranteedEarningsCampaign.num_days_to_complete
  } days. Total Earnings includes all money paid to you by DoorDash, excluding referral payments.  This guarantee means that if your Total Earnings after doing ${
    guaranteedEarningsCampaign.num_deliveries_required
  } trips in ${
    guaranteedEarningsCampaign.num_days_to_complete
  } days is under ${getEarningsString(
    guaranteedEarningsCampaign
  )}, DoorDash will pay you the difference of your ${getEarningsString(
    guaranteedEarningsCampaign
  )} and your Total Earnings. To qualify for this ${getEarningsString(
    guaranteedEarningsCampaign
  )} guarantee, you must complete ${
    guaranteedEarningsCampaign.num_deliveries_required
  } trips within ${
    guaranteedEarningsCampaign.num_days_to_complete
  } days of being activated on the DoorDash platform, and you must also activate your account within 30 days of first signing up.  Cancelled trips, regardless of the reason for the cancellation, do not count as completed trips. We reserve the right to withhold or deduct payments that we determine or believe were in error, fraudulent, illegal, or in violation of the ICA terms or these terms. Guarantee available for a limited time only. Terms subject to change.`

export const getModalTitle = guaranteedEarningsCampaign =>
  `Make ${getEarningsString(guaranteedEarningsCampaign)} in ${
    guaranteedEarningsCampaign.submarket_name
  } when you make ${
    guaranteedEarningsCampaign.num_deliveries_required
  } deliveries in ${guaranteedEarningsCampaign.num_days_to_complete} days`

export const getSignupTitle = guaranteedEarningsCampaign =>
  `Sign Up To Earn ${getEarningsString(guaranteedEarningsCampaign)}`
